var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogosFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_37084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 32.5556C64 14.8827 49.673 0.555664 32 0.555664C14.327 0.555664 0 14.8824 0 32.5556C0 48.5276 11.702 61.7664 27 64.1669V41.8056H18.875V32.5556H27V25.5056C27 17.4856 31.7775 13.0557 39.0868 13.0557C42.588 13.0557 46.25 13.6807 46.25 13.6807V21.5556H42.215C38.2395 21.5556 37 24.0224 37 26.5531V32.5556H45.875L44.4562 41.8056H37V64.1669C52.298 61.7664 64 48.5279 64 32.5556Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4562 41.8057L45.875 32.5557H37V26.5532C37 24.0222 38.2397 21.5557 42.215 21.5557H46.25V13.6807C46.25 13.6807 42.588 13.0557 39.0868 13.0557C31.7775 13.0557 27 17.4857 27 25.5057V32.5557H18.875V41.8057H27V64.1669C28.654 64.4261 30.3258 64.5561 32 64.5557C33.6742 64.5562 35.346 64.4262 37 64.1669V41.8057H44.4562Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_37084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.555664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosFacebook);
export default __webpack_public_path__ + "static/media/logos_facebook.e352b804e5845727466c2491ec9f3d1d.svg";
export { ForwardRef as ReactComponent };